// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1553":"6177ee7860d75594","3039":"4ad7b01246de50ca"}[chunkId] + ".css";
};